import { render, staticRenderFns } from "./SidebarTabSharing.vue?vue&type=template&id=586213f9"
import script from "./SidebarTabSharing.vue?vue&type=script&lang=js"
export * from "./SidebarTabSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports